import CrudActionContainer from './CrudActionContainer';
import commonHandler from '../errorHandlers/common-handler';
import MainMenuController from '../controllers/MainMenuController';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { MainMenuItemModel } from '../model/MainMenuModel';

class MainMenuCRUDActions extends CrudActionContainer {
  resetAction: string;

  constructor() {
    super('MAIN_MENU');
    this.resetAction = super.makeActionKey('RESET');
  }

  create(botId: number, entity: Omit<MainMenuItemModel, 'id'>) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.createAction));
        const response = await MainMenuController.postMainMenu(botId, entity);
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  retrieveAll(botId: number, pageId?: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.retrieveAllAction));
        const response = await MainMenuController.getAll(botId, pageId);
        dispatch(this.retrievedAll(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  update(botId: number, entity: MainMenuItemModel) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.updateAction));
        const response = await MainMenuController.putMainMenu(botId, entity);
        dispatch(this.updateLocal(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  delete(botId: number, entity: MainMenuItemModel) {
    return async (dispatch: Dispatch<StoreState>) => {
      const { id, pageId } = entity;
      try {
        dispatch(this.busy(this.deleteLocalAction));
        dispatch(this.deleteLocal(entity));
        const response = await MainMenuController.deleteMainMenu(
          botId,
          id,
          pageId,
        );
        dispatch(this.retrieveAll(botId, pageId === null ? undefined : pageId));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  reset() {
    return {
      type: this.resetAction,
    };
  }
}

const mainMenuCRUDActions = new MainMenuCRUDActions();

export default mainMenuCRUDActions;

export const useMainMenuCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return useMemo(
    () => ({
      retrieveAll: (botId: number, pageId?: number) =>
        dispatch(mainMenuCRUDActions.retrieveAll(botId, pageId)),
      create: (botId: number, entity: Omit<MainMenuItemModel, 'id'>) =>
        dispatch(mainMenuCRUDActions.create(botId, entity)),
      delete: (botId: number, entity: MainMenuItemModel) =>
        dispatch(mainMenuCRUDActions.delete(botId, entity)),
      update: (botId: number, entity: MainMenuItemModel) =>
        dispatch(mainMenuCRUDActions.update(botId, entity)),
    }),
    [dispatch],
  );
};
